import React, {useMemo} from 'react'
import {useSupplierFormItem} from "../providers/SupplierFormItemProvider";
import {FormInputComponent} from "../../../components/form/Form";
import {Input, Select} from "antd";
const {Option} = Select;


const SupplierProfileLinkForm = (props) => {

    const {
        profileItem,
        profileIndex,
        onModelChange,
        refresh,
        isEditing,
        yearOptions
    } = useSupplierFormItem()

    const linkTypes = useMemo(() => {
        let links = TB.reduce(laravel.talent_profile_link_types || {}, (result, link, linkId) => {
            result.push({...link, value: linkId})
            return result
        }, []);
        let website = TB.find(links, ['name', 'Website']);
        links.unshift(website);
        return TB.uniqBy(links, 'name')
    }, []);

    return (
        <div className="flex flex-col">
            <div className="field-section flex-row">
                <div className="field px-3.5 basis-5/12">
                    <div className="form-links-input">
                        <FormInputComponent
                            fieldName={`type`}
                            value={profileItem.type || null}
                            type="antd-input"
                            required={true}
                            validateBeforeSubmit={false}
                            label={false}
                            placeholder={"Link type"}
                        >

                            <Select value={profileItem.type}>
                                {TB.map(linkTypes, (opt) => (
                                    <Option key={`opt-${profileIndex}-${opt.name}`} value={parseInt(opt.value)}>
                                        <span className="flex flex-row items-center gap-2">
                                            <i className={TB.mapClass(`fa-${opt.icon}`, {
                                                "fab": opt.icon.includes('fa-brand'),
                                                "fas": !opt.icon.includes('fa-brand')
                                            })} style={{color: opt.color}}/>
                                            <span>{opt.name}</span>
                                        </span>
                                    </Option>
                                ))}

                            </Select>
                        </FormInputComponent>
                    </div>
                </div>
            </div>

            <div className="field-section flex-row">
                <div className="field px-3.5 basis-10/12">
                    <FormInputComponent
                        fieldName={`url`}
                        value={profileItem.url}
                        type="antd-input"
                        maxLength={255}
                        validation={{
                            rules: {
                                matchRegexp: /^(http|https):\/\//,
                                isUrl: true,
                            },
                            errors: {
                                matchRegexp: 'Must start with http(s)://',
                                isUrl: TB.trans('validation.active_url', {'attribute': 'link'})
                            }
                        }}
                        validateBeforeSubmit={false}
                        required={!!profileItem.type}
                        label={false}
                        placeholder={TB.trans('talent.profile_link_form.url_label')}>

                        <Input disabled={!profileItem.type} maxLength={255} autoComplete={'off'}/>

                    </FormInputComponent>

                </div>
            </div>
        </div>
    )
}

export default SupplierProfileLinkForm;

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};